import { useEffect, useState, type JSX } from 'react';
import type { EffectProps } from './types';
import { markEffectActivated, isEffectActivated } from './effectRegistry';

export function ScreenDistortion({ params, trigger, triggerDelayMs, onComplete, children, effectKey }: EffectProps): JSX.Element {
  const alreadyActivated = effectKey ? isEffectActivated(effectKey) : false;
  const [active, setActive] = useState(alreadyActivated);

  const distortionType = (params.distortionType as string) ?? 'wave';
  const intensity = (params.intensity as number) ?? 0.5;

  // 一度発動したらノードが切り替わるまで永続（active=trueのまま）
  useEffect(() => {
    if (alreadyActivated) return;
    const delay = trigger === 'after_delay' ? triggerDelayMs : 0;
    const startTimer = setTimeout(() => {
      setActive(true);
      if (effectKey) markEffectActivated(effectKey);
      onComplete?.();
    }, delay);
    return () => clearTimeout(startTimer);
  }, [trigger, triggerDelayMs, onComplete, alreadyActivated, effectKey]);

  const distClass = active
    ? `sn-distortion sn-distortion--${distortionType} sn-distortion--i${Math.round(intensity * 10)}`
    : '';

  return (
    <div className={distClass} style={{ position: 'relative' }}>
      {children}
    </div>
  );
}
